// © Microsoft Corporation. All rights reserved.
import { PeregrineFlightPrefix, Prong1FlightsPrefix, Prong2FlightPrefix, widgetFlightsPrefix } from "@msnews/experiences-constants";
/**
 * Goes through the array of flights that is given and will filter out any flight that doesn't start with prg-pw.
 * @param flights Array
 * @returns specific flights
 */
export function getPeregrineWidgetFlights(flights) {
    return getPeregrineFlights(flights, widgetFlightsPrefix);
}
/**
 * Goes through the array of flights that is given and will filter out any flight that doesn't start with
 * prg-. It then sorts them and returns a new string[].
 * @param flights Array of flights that we will filter through and return only the peregrine
 * @param flightPrefix Prefix of the flight ids used for the filter
 * @returns specific flights
 */
export function getPeregrineFlights(flights, flightPrefix = PeregrineFlightPrefix) {
    const prefixLen = flightPrefix.length;
    const prgPrefixFlights = [];
    if (flights && flights.length) {
        flights.forEach(item => {
            const cleanItem = item && item.trim();
            if (cleanItem
                && cleanItem.length >= prefixLen
                // much faster to do a substring for the first few characters
                // than to do a lowercase on the whole flight string (also faster than case-insensitive regex)
                && cleanItem.substring(0, prefixLen).toLowerCase() === flightPrefix) {
                prgPrefixFlights.push(cleanItem.toLowerCase());
            }
        });
        prgPrefixFlights.sort();
    }
    return prgPrefixFlights;
}
/**
 * Goes through the array of flights that is given and will retrun the correct prefix to filter out any
 * unwanted flights. By default this will return the prefix to only keep flights with prefix 'prg-'
 * @param flights Array of flights that we will filter through
 * @param shouldUseWPOnlyFlights Flag to keep only prg-pw- flights
 * @param appType App type
 * @returns prefix for flights to keep
 */
export function getFlightsFilterPrefix(flights, shouldUseWPOnlyFlights = false, appType = "") {
    let filterPrefix = PeregrineFlightPrefix;
    if (shouldUseWPOnlyFlights) {
        filterPrefix = widgetFlightsPrefix;
    }
    else if (appType.toLocaleLowerCase() === "windowsShell" /* AppType.WindowsShell */.toLocaleLowerCase() ||
        appType.toLocaleLowerCase() === "windowsShellV2" /* AppType.WindowsShellV2 */.toLocaleLowerCase()) {
        filterPrefix = Prong1FlightsPrefix;
    }
    else if (appType.toLocaleLowerCase() === "winWidgets" /* AppType.WindowsNewsWidgets */.toLocaleLowerCase()
        && !isVpTest()) {
        filterPrefix = Prong2FlightPrefix;
    }
    return filterPrefix;
}
/**
 * Checks if the current page is a VP test page
 * We will not import extra libraries due to circle dependencies
 * @returns boolean
 */
function isVpTest() {
    return window?.location?.search?.includes("reqsrc=vp") || !!window?.location?.search?.includes("vptest");
}
//# sourceMappingURL=GetPeregrineFlights.js.map